import React, { useMemo } from 'react';

import { useSearch } from '../../Search';
import { buildTreeOptions } from '../../../../utils';
import { useAxisData } from '../../../../contexts/AxisDataContext';
import Searchindsutry from '../../../../components/Filters/SearchIndustries/SearchIndustries';

function SearchIndustryFilterWrapper() {
  const {
    searchIndustries,
    setSearchIndustries,
    isFacetResultsLoading,
    isEntityResultsLoading,
  } = useSearch();

  const { briefs } = useAxisData();

  const options = useMemo(() => {
    return buildTreeOptions(briefs);
  }, [briefs]);

  const isLoading = isEntityResultsLoading || isFacetResultsLoading;

  return (
    <Searchindsutry
      options={options}
      isLoading={isLoading}
      applyFilters={setSearchIndustries}
      activeIndustryFilters={searchIndustries}
    />
  );
}

export default SearchIndustryFilterWrapper;
